import { Box, Button, Card, TableCell, TableRow } from "@mui/material";
import { useState, useRef } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import StyledTable from "../../../../shared/StyledTable/StyledTable";
import OperatorModal from "../OperatorModal/OperatorModal";
import useFetchWithAuth from "../../../../features/hooks/useFetchWithAuth";

const TabContent = ({ tabIndex, search = "" }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedOperator, setSelectedOperator] = useState(null);
  const modalRef = useRef(null);

  const url =
    tabIndex === 0
      ? "/user/operators/status/fired/"
      : "/user/operators/status/blocked/";

  const { data, loading, error } = useFetchWithAuth(url);
  console.log("Fetched operators:", data);

  const filtered = (data || []).filter((op) => {
    const fullName = `${op.first_name || ""} ${op.last_name || ""} ${
      op.username || ""
    }`.toLowerCase();
    return fullName.includes((search || "").toLowerCase());
  });

  const rows = filtered.map((op) => ({
    operator: `${op.first_name || ""} ${op.last_name || ""}`.trim() || "-",
    startEnd: `${op.date_of_start || "-"} - ${op.date_of_end || "-"}`,
    birthDate: op.birthday_date || "-",
    login: op.username || "-",
    fullData: op,
  }));

  if (loading) return <p>Завантаження...</p>;
  if (error) return <p>Помилка: {error.message}</p>;

  return (
    <>
      <Card sx={{ px: 4, py: 2, borderRadius: "7px" }}>
        <StyledTable
          headers={[
            "Оператор",
            "Початок - кінець",
            "Дата народження",
            "Логін",
            "",
          ]}
          rows={rows}
          renderRow={(operator, index) => (
            <TableRow key={index}>
              <TableCell
                className="border-bottom"
                sx={{ padding: "14px 20px", fontSize: 14 }}
              >
                {operator.operator}
              </TableCell>
              <TableCell
                className="border-bottom"
                sx={{ padding: "14px 20px", fontSize: 14 }}
              >
                {operator.startEnd}
              </TableCell>
              <TableCell
                className="border-bottom"
                sx={{ padding: "14px 20px", fontSize: 14 }}
              >
                {operator.birthDate}
              </TableCell>
              <TableCell
                className="border-bottom"
                sx={{ padding: "14px 20px", fontSize: 14 }}
              >
                {operator.login}
              </TableCell>
              <TableCell
                className="border-bottom"
                sx={{ padding: "14px 20px" }}
              >
                <Box display="flex" justifyContent="end">
                  <Button
                    onClick={() => {
                      setSelectedOperator(operator.fullData);
                      setModalOpen(true);
                    }}
                  >
                    <MoreVertIcon fontSize="small" />
                  </Button>
                </Box>
              </TableCell>
            </TableRow>
          )}
        />
      </Card>

      <OperatorModal
        open={modalOpen}
        modalRef={modalRef}
        onClose={() => setModalOpen(false)}
        operatorData={selectedOperator}
      />
    </>
  );
};

export default TabContent;
